import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dd88cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "player-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fad fa-play-circle" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fad fa-pause-circle" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 2,
  class: "player__tracker"
}
const _hoisted_7 = { class: "player__times" }
const _hoisted_8 = { class: "player__time player__time--start" }
const _hoisted_9 = { class: "player__time player__time--end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "player__line" }, null, -1))
const _hoisted_11 = {
  key: 1,
  class: "advert-overlay"
}
const _hoisted_12 = { class: "advert-content" }
const _hoisted_13 = { class: "advert-text" }
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.showAdvert)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["player", {'player--disabled': _ctx.state === 'error'}])
        }, [
          (_ctx.state === 'initial' || _ctx.state === 'paused' || _ctx.state === 'error')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.play()), ["prevent"])),
                href: "",
                class: "player__btn"
              }, _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.state === 'playing')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.pause()), ["prevent"])),
                href: "",
                class: "player__btn"
              }, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.audio)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.currentTime), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.totalTime), 1)
                ]),
                _createElementVNode("div", {
                  class: "player__track",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.seekClick && _ctx.seekClick(...args)), ["prevent"])),
                  onTouchend: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.seekTouch && _ctx.seekTouch(...args)), ["prevent"])),
                  ref: "track"
                }, [
                  _hoisted_10,
                  _createElementVNode("div", {
                    class: "player__marker",
                    style: _normalizeStyle({left: `${_ctx.progress}%`})
                  }, null, 4)
                ], 544)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showAdvert)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", null, " Die recarena-Aufnahme wird geladen" + _toDisplayString(_ctx.countdownText), 1)
            ]),
            _createElementVNode("img", {
              src: _ctx.advertImage,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickAdvertImage && _ctx.clickAdvertImage(...args)))
            }, null, 8, _hoisted_14)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}